<template>
  <ubi-page-container>
    <div v-loading="loading" :element-loading-text="$t('posts.list.chargementDonnees')">

      <ubi-panel :title="$t('posts.list.graphAnnoncesCommerciauxTitle')">
        <el-row>
          <el-col :span="24">
            <div class="text-muted" style="text-align: center;">
              <div v-if="(graphData != null) && (graphData.datasets != null)">
                <bar-chart :chart-data="graphData"></bar-chart>
              </div>
              <div v-else style="text-align: center;">{{ $t("posts.list.graphAnnoncesCommerciauxNoData") }}</div>
              <br>{{ $t("posts.list.graphAnnoncesCommerciauxSubtitle") }}
            </div>
          </el-col>
        </el-row>
      </ubi-panel>

      <ubi-list-header slot="header"
                       :limits="limits"
                       :page.sync="page"
                       :limit.sync=limit
                       :total="results.total_count"
                       :sort.sync="sort"
                       :sortProperties="sortProperties"
                       :defaultFilter="this.filter.preset"
                       @filter="doFilter"
      ></ubi-list-header>
      <el-form label-position="top" @submit.prevent.native="fetchList">
        <ubi-panel class="AnnoncesCommerciaux">
          <el-table ref="tablePostsList" :data="results.list" hide-default-footer disable-pagination>
            <el-table-column :label="$t('posts.list.commercial')" min-width="140">
              <template v-slot="{ row: result }">
                {{ result.commercial }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('posts.list.nbAnnonces')" min-width="200" align="center">
              <template v-slot="{ row: result }">
                {{ result.nb_annonces }}
              </template>
            </el-table-column>
          </el-table>
        </ubi-panel>
      </el-form>
    </div>
  </ubi-page-container>
</template>

<script>

import { getPostsCommercials } from '@/services/posts'
import { mapMutations, mapState } from 'vuex'
import { posts } from '@/stores/posts'
import PieChart from '@/services/piechart'
import BarChart from "@/services/barchart";

export default {
  name: 'annoncesCommerciaux',
  components: { BarChart },
  data () {
    return {
      loading: false,
      filters: [],
      limits: [500],
      limit: 500,
      sortProperties: {
        nb_annonces: this.$t('posts.list.annoncesActivesDecroissantes'),
        '-nb_annonces': this.$t('posts.list.annoncesActivesCroissantes'),
        commercial: this.$t('posts.list.commercialDecroissant'),
        '-commercial': this.$t('posts.list.commercialCroissant')
      },
      graphData: {
        labels: [],
        datasets: []
      }
    }
  },
  computed: {
    ...mapState('annoncesCommerciaux', ['filter', 'results']),
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.filter.page = value
        this.fetchList()
      }
    },
    /*limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
      }
    },*/
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        await this.fetchList()
      }
    }
  },
  methods: {
    ...mapMutations('annoncesCommerciaux', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter'
    ]),
    async fetchList () {
      this.loading = true
      const result = await getPostsCommercials(this.filter)
      this.setResults(result)
      const labels = []
      const valeurs = []
      const colors = []
      let cpt1 = 255
      let cpt2 = 200
      let cpt3 = 0
      result.list.forEach(function (element) {
        labels.push(element.commercial)
        valeurs.push(element.nb_annonces)
        cpt1 = Math.floor(Math.random() * 255)
        cpt2 = Math.floor(Math.random() * 200)
        cpt3 = Math.floor(Math.random() * 200)
        colors.push('rgba(' + cpt1 + ', ' + cpt2 + ', ' + cpt3 + ', 0.55)')
      })
      this.graphData = {
        labels: labels,
        datasets: [{
          label: '# Annonces',
          data: valeurs,
          backgroundColor: colors,
          borderWidth: 0
        }]
      }
      this.loading = false
    },
    doFilter (type) {
      this.filter.preset = type
      switch (type) {
        case 'reset':
          this.resetFilter()
          break
      }
      this.fetchList()
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value, lengthMax) {
      if (!value) return ''
      value = value.toString().substr(0, lengthMax)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  async beforeMount () {
    if (this.$route.params.reset) {
      this.resetFilter()
    }
    await this.fetchList()
  }

}

</script>

<style scoped>

</style>
